import * as userAction from "../actions/search.action";
const user = (
  state = {
    status: null,
    loading: false,
    error: null,
    agentsData: null
  },
  action
) => {
  switch (action.type) {
    case userAction.SEARCH_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true
      });
    case userAction.SEARCH_SUCCESS:
      return Object.assign({}, state, {
        agentsData: action.agents,
        status: action.status,
        loading: false
      });
    case userAction.SEARCH_FAILURE:
      return Object.assign({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};
export default user;
